import { render } from "./PDFParadigmHandling.vue?vue&type=template&id=2c8af7b0&ts=true"
import script from "./PDFParadigmHandling.vue?vue&type=script&lang=ts"
export * from "./PDFParadigmHandling.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__